const SCORE_DISTRIBUTION_ACROSS_KEY_AREAS_DESCRIPTION =
  "This shows how the Halo Intrinsic Score is distributed across each of your company's key enterprise risk areas.";

export default SCORE_DISTRIBUTION_ACROSS_KEY_AREAS_DESCRIPTION;
